import { sitePhrasing } from "../../../../Language/languageHandler";
import { AddressInputFieldGroup } from "../../../FormFields/AddressFieldGroup/AddressInputFieldGroup";
import CheckboxInputField from "../../../FormFields/CheckboxInputField/CheckboxInputField";
import TextInputField from "../../../FormFields/TextInputField/TextInputField";
import { ContactInfoFields } from "../ContactInfoFields";
import { annualReportDisclaimer1, electronicSignatureSublabel, iAgreeText, laborLawPosterAgreementText, mayBeContactedAgreementText, stateTransactionAcknowledgmentText } from "../PurchaseConstants";
import { AnnualReferenceNumberInstructions, TermsAndConditionAcceptText } from "../SharedPurchaseFieldComponents";

export default function NorthCarolinaPastDueAnnualReportFields(props: {
  errors: any;
  touched: any;
  values: any;
  setFieldValue: (field: string, value: any) => void;
  selectedProducts: any;
}) {
  const {
    errors,
    touched,
    values,
    setFieldValue,
    selectedProducts
  } = props;

  return (
    <>

      <ContactInfoFields
        values={values}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
      />

      <TextInputField
        mask={sitePhrasing.referenceMask}
        fieldName={"referenceNumber"}
        fieldLabel={"Reference Number"}
        fieldSubLabel={undefined}
        customFieldInstructions={() => (<AnnualReferenceNumberInstructions />)}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Reference Number"}
        maskGuide={sitePhrasing.referenceMaskGuide}
      />

      <div className="terms-and-conditions-container">
        {mayBeContactedAgreementText}
        <br /><br />
        {annualReportDisclaimer1}
        <br /><br />
        The above company is the entity I intend to file an annual report for. I am authorized to file an annual report for the above company.
        <br /><br />
        {iAgreeText}
        <br /><br />
        {selectedProducts["laborLawPoster"] && (
          <>
            {laborLawPosterAgreementText}
            <br /><br />
          </>
        )}
        {stateTransactionAcknowledgmentText}
        <br /><br />
        <TermsAndConditionAcceptText />
      </div>

      <CheckboxInputField
        fieldName={'termAndConditionAgree'}
        fieldLabel={`I've read and accept the terms and conditions.`}
        touched={touched}
        errors={errors}
        onChange={(e: any) => {
          const checkedVal = e.target.checked ? true : false;
          setFieldValue('annualReport.annualAgree', checkedVal)
          setFieldValue('annualReport.iAmAuthorized', checkedVal)
          setFieldValue('iAgree', checkedVal)
          setTimeout(() => {
            setFieldValue('termAndConditionAgree', checkedVal)
          }, 0)

        }}
      />


      {/* <CheckboxInputField
        fieldName={'annualReport.annualAgree'}
        fieldLabel={annualReportDisclaimer1}
        touched={touched}
        errors={errors}
      />

      <CheckboxInputField fieldName={'iAgree'} fieldLabel={iAgreeText} touched={touched} errors={errors} />

      <CheckboxInputField
        fieldName={'termAndConditionAgree'}
        fieldLabel={<span dangerouslySetInnerHTML={{ __html: termAndConditionAcceptText }} />}
        touched={touched}
        errors={errors}
      /> */}

      <TextInputField
        fieldName={"annualReport.electronicSignature"}
        fieldLabel={"Name of Individual Signing - Electronic Signature"}
        fieldSubLabel={electronicSignatureSublabel}
        fieldSubLabelCustomClass={'red-text'}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Electronic Signature"}
        customClass={"signature-font"}
      />

      <TextInputField
        fieldName={"annualReport.title"}
        fieldLabel={"Title"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Title"}
      />

      {/* <CheckboxInputField
        fieldName={'annualReport.iAmAuthorized'}
        fieldLabel={`The above company is the entity I intend to file an annual report for. I am authorized to file an annual report for the above company`}
        touched={touched}
        errors={errors}
      /> */}

      <AddressInputFieldGroup
        fieldName={"annualReport.signerAddress"}
        errors={errors}
        touched={touched}
      />

    </>)
}